import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Box, Button, ButtonGroup, Grid, InputAdornment, TextField, Theme, useMediaQuery } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Slider from '@mui/material/Slider';
import Tab from '@mui/material/Tab';
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';
import { InputPicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { useGetIdentityOptimized } from '../components/identity';
import { HasPermission } from '../resources/payrolls/Payrolls';
import { NUMBER } from '../utils/Constants/MagicNumber';
import { GoalInputTooltip, PercentageCompleteHtmlView, PercentageDefaultMessage, ProgressTooltip, SadHappySvgHtml, SetGoalResult, ShowAlertHtml, ShowMessageDefaultState, formatter, getTeamGoal, getTeamNegPerComplete, getTeamPerComplete, workerAndTeamDetailsforNegPerComplete, workerAndTeamDetailsforPerComplete, workerAndTeamDetailsforSetGoal } from './BonusCalculatorDashboard';
import _ from 'lodash';
import get from 'lodash/get';

const BonusCalculatorDetailPage = (props: any) => {
    const { record, maxHours, workerPreview } = props;
    const employeeWageIds = record?.has_milestones ? record?.milestone_employee_wage_ids : record?.employee_wage_ids;
    const propay = record;
    const defaulMilestone = {
        label: record?.display_name,
        value: record.id,
        actual_amount: propay.attendance_earning,
        actual_hours: propay.hours,
        budget_amount: propay.budget,
        class: 'rsuite-menu-parent',
        bonus_split_type: propay.bonus_split_type,
        budget_hours: maxHours,
        budget_option: propay.budget_option,
        is_bonus_pool_enabled: propay?.is_bonus_pool_enabled,
        worker_bonus_percent: propay?.worker_bonus_percent,
        employees: employeeWageIds?.length
          ? employeeWageIds.map((employee) => ({
              label: employee?.employee_id_obj?.display_name,
              value: employee.employee_id,
              active: employee?.employee_id_obj?.active,
              base_wage: Number((employee.base_wage*NUMBER.ONE).toFixed(NUMBER.TWO)),
              worked_hours: employee.hours,
              is_remove_bonus: employee.is_remove_bonus,
              bonus_per: employee.bonus_per,
            }))
          : []
    }

    const { identity } = useGetIdentityOptimized();
    const [tab, settabs] = React.useState('Set-Goal');
    const [milestone, setMilestone] = React.useState(record?.has_milestones ? null : defaulMilestone);
    const [actualValue, setActualValue] = React.useState(null);
    const [actualPercentComplete, setActualPercentComplete] = React.useState<any>(NUMBER.ZERO);
    const [budgetValue, setBudgetValue] = React.useState(null);
    const [value, setValue] = React.useState<any>(null);
    const [employees, setEmployees] = React.useState([]);
    const [employee, setEmployee] = React.useState(null);
    const [crewSize, setCrewSize] = React.useState(null);
    const [employeeHours, setEmployeeHours] = React.useState(null);
    const [percentComplete, setPercentComplete] = React.useState<any>(null);
    const [hoursError, setHoursError] = React.useState<boolean>(false);
    const [crewError, setCrewError] = React.useState<boolean>(false);
    const [crewEdited, setCrewEdited] = React.useState<boolean>(false);
    const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    const [showCalculation, setShowCalculation] = React.useState<boolean>(isSmall ? false : true);

    React.useEffect(()=> {
     if(!isSmall){
        setShowCalculation(true);
     }else{
        setShowCalculation(false);
     }
    },[isSmall]);

    const numericValue = parseFloat(actualPercentComplete) || NUMBER.ZERO;
    const PerCompletePositiveNegative = Number((percentComplete - numericValue).toFixed(NUMBER.TWO));

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        settabs(newValue);
        setPercentComplete('');
        setValue('');
    };

    const handleOnblurCrewChange = () => {
        const newCrewSize = Number(crewSize);
        if (!isNaN(newCrewSize) && newCrewSize <= NUMBER.ZERO) {
            const crewCount = milestone?.employees?.filter((item) => item.worked_hours > NUMBER.ZERO)?.length ?
            milestone?.employees?.filter((item) => item.worked_hours > NUMBER.ZERO)?.length : milestone?.employees?.length;
            setCrewSize(employee?.worked_hours ? crewCount : milestone?.employees?.length < crewCount ? crewCount+1:crewCount);
            setCrewError(true);
            setTimeout(()=>setCrewError(false), NUMBER.SIX_THOUSAND)
        }
    };

    const handleInputChange = (event) => {
        let inputValue = event.target.value;
        const regex = /^\d*(\.\d{0,1})?$/;
        if (regex.test(inputValue)) {
            if (inputValue !== '' && Number(inputValue) <= NUMBER.HUNDRED) {
                setValue(Number(inputValue));
            }
        }
        if (inputValue === '') {
            setValue('');
        }
    };

    const handleSliderChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleInputPercentChange = (event) => {
        let inputValue = event.target.value;
        // Check if the input is a valid number
        if (!isNaN(inputValue) && inputValue !== '' && Number(inputValue) <= NUMBER.HUNDRED) {
            setPercentComplete(Number(inputValue));
        }
        if (inputValue === '') {
            setPercentComplete('');
        }
    };

    const handleSliderPercentChange = (event, newValue) => {
        setPercentComplete(newValue);
    };

    const combineAndMakeUniqueArray = (allEmployees, employeesWage) => {
        /* Find entries from all_employee_wage_ids that are not in the uniqueEmployeeWage array */
        const notInEmployeeWage = allEmployees.filter(emp => !employeesWage.find(e => e.employee_id === emp.employee_id));
        /* Set the hours to 0 for notInEmployeeWage entries */
        const notInEmployeeWageWithHoursZero = notInEmployeeWage.map(emp => ({ ...emp, hours: 0 }));
        /* Combine the arrays */
        const resultArray = [...employeesWage, ...notInEmployeeWageWithHoursZero];
        return resultArray;
    }

    const data = propay ? propay?.milestone_ids?.map((milestone) => {

        const max_hours = _.round(get(milestone, "estimated_hours"), NUMBER.TWO);
        const employeesArray = combineAndMakeUniqueArray(record?.employee_wage_ids, milestone?.employee_wage_ids);
    return {
        label: milestone.name,
        value: milestone.id,
        actual_amount: milestone.attendance_earning,
        actual_hours: milestone.hours,
        budget_amount: milestone.budget,
        class: 'rsuite-menu-parent',
        bonus_split_type: propay.bonus_split_type,
        budget_hours: max_hours,
        budget_option: propay.budget_option,
        is_bonus_pool_enabled: propay?.is_bonus_pool_enabled,
        worker_bonus_percent: propay?.worker_bonus_percent,
        employees: employeesArray?.length
          ? employeesArray.map((employee) => ({
              label: employee?.employee_id_obj?.display_name,
              value: employee.employee_id,
              active: employee?.employee_id_obj?.active,
              base_wage: Number((employee.base_wage*NUMBER.ONE).toFixed(NUMBER.TWO)),
              worked_hours: employee.hours,
              is_remove_bonus: employee.is_remove_bonus,
              bonus_per: employee.bonus_per,
            }))
          : []
    }}
    ) : [];

    const marks = [
        {
            value: 0,
            label: '0%',
        },
        {
            value: 100,
            label: '100%',
        },
    ];

    const employeeCount = (count, item) => (count > NUMBER.ONE ? [{ label: 'All', value: 'All' }, ...item] : item);
    const employeeId = workerPreview?.show ? workerPreview.employee_id : identity?.employee_id;
    const handleEmployeeSet = (item) => {
        return (identity?.user_type === 'worker' || workerPreview?.show) ? item?.filter((data) => data.value === employeeId) : employeeCount(item?.length, item)
    }

    const employeeCountsetEmployee = (item) => {
        const worker = item?.filter((data) => data.value === employeeId)
        return((identity?.user_type === 'worker' || workerPreview?.show) ? worker?.length ? worker[0]: null: (item?.length ? { label: 'All', value: 'All' } : null))
    };

    const handlePropayChange = (val, item) => {
        setMilestone(item);
        setCrewEdited(false);
        setValue('');
        setPercentComplete('');
    }

    React.useEffect(() => {
        if(milestone){
        const employeeData = milestone?.bonus_split_type === 'by_percentage' ? milestone?.employees?.filter((data) => !data?.is_remove_bonus && data?.bonus_per && data?.active) : milestone?.employees?.filter((data) => !data?.is_remove_bonus && data?.active);
        const singleEmployee = employeeData?.length === NUMBER.ONE ? employeeData?.[NUMBER.ZERO] : employeeCountsetEmployee(employeeData);
        const employeesArray = (employeeData?.length > NUMBER.ONE && identity?.user_type !== 'worker' && !workerPreview?.show) ? [{ label: 'All', value: 'All' }, ...employeeData] : handleEmployeeSet(employeeData);
        setEmployees(employeesArray);
        setEmployee(singleEmployee);
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [milestone, identity,workerPreview]);

    const handlePropayClear = (val) => {
        setEmployees([]);
        setMilestone(null);
        setEmployee(null);
        setPercentComplete('');
        setValue('');
        settabs('Set-Goal');
        setCrewEdited(false);
    }


    const handleEmployeeChange = (val, ele) => {
        setEmployee(ele);
        setPercentComplete('');
        setValue('');
    }

    const handleCrewChange = (e) => {
        const newCrewSize = parseInt(e.target.value, 10);
        if (!isNaN(newCrewSize)) {
            setCrewSize(newCrewSize);
            setCrewEdited(true);
        }
        if (e.target.value.trim() === '') {
            setCrewSize('');
            setCrewEdited(true);
        }
    };

    React.useEffect(() => {
        if (milestone) {
            const crewCount = milestone?.employees?.filter((item) => item.worked_hours > 0)?.length ?
                milestone?.employees?.filter((item) => item.worked_hours > 0)?.length : milestone?.employees?.length;
            setActualPercentComplete(`${milestone.budget_amount? (NUMBER.HUNDRED * (milestone.actual_amount / milestone.budget_amount)).toFixed(NUMBER.TWO):0}%`);
            setActualValue(`${(milestone.actual_hours*NUMBER.ONE).toFixed(NUMBER.TWO)} hrs. / ${formatter.format(Number((milestone.actual_amount*NUMBER.ONE).toFixed(NUMBER.TWO)))} `);
            setBudgetValue(`${milestone.budget_hours.toFixed(NUMBER.TWO)} hrs. / ${formatter.format(Number((milestone.budget_amount*NUMBER.ONE).toFixed(NUMBER.TWO)))}`);
            setCrewSize(employee?.worked_hours ? crewCount : milestone?.employees?.length < crewCount ? crewCount+1:crewCount);
        } else {
            setActualPercentComplete('');
            setActualValue('');
            setBudgetValue('');
            setCrewSize(null);
        }

    }, [propay, employee, milestone])

    const goals = React.useMemo(() => {
        if ( tab === 'Set-Goal' && value && (milestone || employee)) {
            return workerAndTeamDetailsforSetGoal(milestone, employee, Number(value), Number(crewSize ? crewSize : 1));
        } else if (tab === '%-complete' && percentComplete && (milestone || employee) && PerCompletePositiveNegative >=0) {
            return workerAndTeamDetailsforPerComplete(milestone, employee, percentComplete, numericValue, Number(crewSize ? crewSize : 1), crewEdited);
        } else if (tab === '%-complete' && percentComplete && (milestone || employee) && PerCompletePositiveNegative <0) {
            return workerAndTeamDetailsforNegPerComplete(milestone, employee, percentComplete);
        }
    }, [tab, value, milestone, employee, percentComplete, PerCompletePositiveNegative, crewSize, numericValue, crewEdited]);

    const teamGoal = React.useMemo(() => {
        if (tab === 'Set-Goal' && value && (milestone || employee)) {
            return getTeamGoal(milestone, Number(value));
        } else if (tab === '%-complete' && percentComplete && (milestone || employee) && PerCompletePositiveNegative >=0) {
            return getTeamPerComplete(milestone, percentComplete, numericValue);
        } else if (tab === '%-complete' && percentComplete && (milestone || employee) && PerCompletePositiveNegative <0) {
            return getTeamNegPerComplete(milestone, percentComplete);
        }
    }, [tab, value, milestone, employee, percentComplete, PerCompletePositiveNegative, numericValue]);

    const calculatedActual = employee?.value === 'All' ? teamGoal : goals

    React.useMemo(() => {
        if (goals && employee?.value !== 'All') {
            setEmployeeHours(goals?.worker_hours)
        }
    }, [goals, employee]);

    const handleHoursChange = (e) => {
        const { value } = e.target;
        const regex = /^\d*(\.\d{0,2})?$/;
        if (regex.test(value)) {
          const newEmployeeHours = Number(value);
          if (newEmployeeHours <= goals?.worker_max_hours) {
            setEmployeeHours(value);
          }
        }
        if (value.trim() === '') {
          setEmployeeHours('');
        }
      };

      const handleOnblurHoursChange = () => {
        const newHours = Number(employeeHours);
        if (!isNaN(newHours) && newHours < employee?.worked_hours && tab === 'Set-Goal') {
            setEmployeeHours(Number((employee?.worked_hours * 1).toFixed(NUMBER.TWO)));
            setHoursError(true);
            setTimeout(()=>setHoursError(false), NUMBER.SIX_THOUSAND);
        }else if(!isNaN(newHours) && newHours < employee?.worked_hours && tab === '%-complete'){
            setEmployeeHours(Number((goals?.worker_hours * 1).toFixed(NUMBER.TWO)));
            setHoursError(true);
            setTimeout(()=>setHoursError(false), NUMBER.SIX_THOUSAND);
        }else{
            const roundedHours = newHours % 1 === 0 ? newHours.toFixed(1) : newHours.toFixed(2);
            setEmployeeHours(roundedHours);
        }
    };


    const potentialTeamBonus = calculatedActual && (calculatedActual?.team_hours * calculatedActual?.bonus_rate || NUMBER.ZERO).toFixed(NUMBER.TWO);
    const workerBonus = calculatedActual && (Number(employeeHours) > employee?.worked_hours ? Number(employeeHours) * calculatedActual?.bonus_rate : employee?.worked_hours * calculatedActual?.bonus_rate || NUMBER.ZERO).toFixed(NUMBER.TWO);
    const potentialWorkerBonus= milestone?.bonus_split_type === 'by_percentage' ? (Number(potentialTeamBonus)*employee?.bonus_per) : workerBonus;
    const WorkerWageIncrease = milestone?.bonus_split_type === 'by_percentage' ? calculatedActual && (calculatedActual.base_wage + (calculatedActual.bonus_rate*employee?.bonus_per)).toFixed(NUMBER.TWO)
    :calculatedActual && (calculatedActual.base_wage + calculatedActual.bonus_rate).toFixed(NUMBER.TWO) || NUMBER.ZERO;
    const compnayPerDay = identity?.company?.hours_per_day;
    const TotalManDays = calculatedActual && (calculatedActual.team_hours / compnayPerDay || NUMBER.ZERO).toFixed(NUMBER.TWO);
    const TotalWorkedDays = TotalManDays && crewSize && (Number(TotalManDays) / crewSize || NUMBER.ZERO).toFixed(NUMBER.TWO);
    const overageAmount = Number((milestone?.budget_amount - milestone?.actual_amount).toFixed(NUMBER.TWO));
    const overageHours = Number((milestone?.budget_hours - milestone?.actual_hours).toFixed(NUMBER.TWO));
    const wages = employee?.value === 'All' ? employees.some((employee) => {
        return employee.base_wage > 0;
      }) : employee?.base_wage;

      const renderMenuItem = (label, item) => {
        return (
          <div className={`rs-picker-option ${item.class}`}>
            <span>{label}</span>
          </div>
        );
      };

    return (
            <HasPermission resource="propay_calculator" action="read">
                <Grid container spacing={0} className="bonus-calculator">
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        className="left-calculator"
                    >
                        <Grid
                            container
                            spacing={2}
                            className="left-calculator-cont"
                        >
                            {record?.has_milestones && <Grid item xs={12} sm={12} md={6} className='relative'>
                                <InputPicker
                                    className='no-translate'
                                    size="lg"
                                    groupBy="role"
                                    block
                                    data={data}
                                    placeholder="Milestone"
                                    onClean={(event) => handlePropayClear(event)}
                                    onSelect={(value, item) => handlePropayChange(value, item)}
                                    renderMenuItem={renderMenuItem}
                                />
                                {milestone && <div className='calculator-propay-label'>Milestone</div>}
                            </Grid>}
                            <Grid item xs={12} sm={12} md={6} className='worker-assigned-grid'>
                                <Autocomplete
                                    id="workers-assigned"
                                    onChange={(value, ele) => handleEmployeeChange(value, ele)}
                                    options={employees}
                                    value={employee}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Workers Assigned"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    disabled={true}
                                    value={budgetValue}
                                    id="budget-hours"
                                    label="Budget (hrs. / $)"
                                    variant="outlined"
                                    className={`${budgetValue ? '' : 'budget-label-down'} budget-actual-input pr-zero`}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        setBudgetValue(event.target.value);
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} className='relative propay-actual-hour'>
                                <TextField
                                    id="Actual"
                                    value={actualValue}
                                    disabled={true}
                                    label="Actual (hrs. /$)"
                                    variant="outlined"
                                    className={`${budgetValue ? '' : 'budget-label-down'} budget-actual-input`}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        setActualValue(event.target.value);
                                    }}
                                    fullWidth
                                />
                                <Tooltip title="Percentage of budget spent" arrow placement="top">
                                <div className='actual-percentage-hour'>{actualPercentComplete}</div>
                                </Tooltip>
                            </Grid>
                        </Grid>
                        {((milestone || employee) && (!isNaN(overageAmount) && overageAmount<= NUMBER.ZERO || !wages) ?
                        <ShowAlertHtml overageAmount={overageAmount} wages={wages} overageHours={overageHours} employee={employee}/>
                         :((milestone || employee) && <div className="calculator-tabs">
                            <TabContext value={tab}>
                                <TabList
                                    onChange={handleChange}
                                    aria-label="Calculator tabs example"
                                    className={`${numericValue > NUMBER.ONE ? '':'set-goal-full-width'}`}
                                >
                                    <Tab label="Set Goal" value="Set-Goal" />
                                    {numericValue > NUMBER.ONE &&  <Tab
                                        label="% complete"
                                        value="%-complete"
                                    />}
                                </TabList>
                                <TabPanel value="Set-Goal">
                                    <h3>
                                    {numericValue ? 'How much do you plan to beat the remaining budget?' : 'How much do you plan to beat the budget?'}{' '}
                                    </h3>
                                    <h5>
                                        Just use the slider or enter percentage!
                                    </h5>
                                    <Box className="percentage-box percentage-box-full-width">
                                        <ButtonGroup>
                                            <div className={`${value ? '' : 'input-slider-unique-percentage'} input-slider-percentage`}>
                                                <TextField
                                                    value={value}
                                                    defaultValue={null}
                                                    id='percentage-input-goal'
                                                    onChange={handleInputChange}
                                                    placeholder="Enter percentage"
                                                    type={numericValue >= 97 ? 'text':'number'}
                                                    className='MuiInput-input-custom-cs'
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                               {value ? '%' : '' }
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </div>
                                            <Button className={`${numericValue ? '' : 'unique-percentage-btn'} percentage-btn`} style={{ width: `${0}%` }}>
                                                Button One
                                            </Button>
                                        </ButtonGroup>
                                        <Slider
                                            value={Number(value) ? Number(value) : NUMBER.ZERO }
                                            onChange={handleSliderChange}
                                            step={numericValue >= 97 ? 0.1 : 1}
                                            aria-labelledby="input-slider"
                                            marks={marks}
                                            valueLabelDisplay="auto"
                                        />
                                        {/* <div className="slider-smiley-icon">
                                            <SadHappySvgHtml condition={Number(value) <= (NUMBER.HUNDRED - numericValue)}/>
                                        </div> */}
                                    </Box>
                                </TabPanel>
                                {numericValue > NUMBER.ONE && <TabPanel value="%-complete">
                                    <h3>How much is completed?</h3>
                                    <h5>
                                        Just use the slider or enter percentage!
                                    </h5>
                                    <Box className="percentage-box profit-percentage">
                                        <ButtonGroup>
                                            <div className={`${percentComplete ? '': 'input-slider-unique-percentage'} input-slider-percentage`} >
                                                <TextField
                                                    type='number'
                                                    value={percentComplete}
                                                    id='percentage-input-%'
                                                    onChange={handleInputPercentChange}
                                                    placeholder="Enter percentage"
                                                    className='MuiInput-input-custom-cs'
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {percentComplete ? '%' : '' }
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </div>
                                            <Button className="percentage-btn" style={{ width: `${numericValue}%` }}>
                                                {/* we will use this code in future */}
                                                {/* <span className='percentage-tooltip' data-value="51.25%"><em></em></span> Button Two */}
                                                <GoalInputTooltip title=''
                                                // title={
                                                // // <React.Fragment>
                                                // //  <div className='tooltip-percent-text'>
                                                // // <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                // // <circle cx="4.82617" cy="4" r="4" fill="#E9F6FA"/>
                                                // // </svg>
                                                // // 8.75%</div>
                                                // // </React.Fragment>
                                                // }
                                            >
                                                <Button>Goal Input Tooltip</Button>
                                            </GoalInputTooltip>
                                            </Button>
                                            {/* we will use this code in future */}
                                              <ProgressTooltip title=''
                                              PerCompletePositiveNegative={((milestone || employee) && percentComplete ) ? PerCompletePositiveNegative : 0}
                                              perComplete={((milestone || employee)  && percentComplete ) ? percentComplete: 0}
                                              numericValue={numericValue}
                                                // title={
                                                // // <React.Fragment>
                                                // //  <div className='tooltip-percent-text'>
                                                // // {/* <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                // // <circle cx="4.82617" cy="4" r="4" fill="#31B26D"/>
                                                // // </svg> */}
                                                // // <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                // // <circle id="Ellipse 5" cx="4.32617" cy="4" r="4" fill="#B73009"/>
                                                // // </svg>
                                                // // 8.75%</div>
                                                // // </React.Fragment>
                                                // }
                                            >
                                                <Button>HTML</Button>
                                            </ProgressTooltip>
                                            {/* we will use this code in future */}
                                            {/* <Tooltip title="8.75%" style={{ left: `50%` }} arrow>
                                            <Button className='progress-percentage green-percentage'>Arrow</Button>
                                            </Tooltip> */}

                                        </ButtonGroup>
                                        <Slider
                                            value={
                                                typeof percentComplete === 'number'
                                                    ? percentComplete
                                                    : NUMBER.ZERO
                                            }
                                            onChange={handleSliderPercentChange}
                                            aria-labelledby="input-slider"
                                            marks={marks}
                                            valueLabelDisplay="auto"
                                        />
                                        <div className="slider-smiley-icon">
                                        <SadHappySvgHtml condition={percentComplete && !isNaN(PerCompletePositiveNegative) && PerCompletePositiveNegative >= 0} />
                                        </div>
                                    </Box>
                                </TabPanel>}
                            </TabContext>
                        </div>))}
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        className="calculator-frame"
                    >
                        {(tab === 'Set-Goal' && (milestone && employee) && value && ((numericValue===0 && value<99.1 || numericValue))  &&
                          (!isNaN(overageAmount) && overageAmount> 0)) ?
                            <SetGoalResult
                                crewSize={crewSize}
                                hoursError={hoursError}
                                handleOnblurHoursChange={handleOnblurHoursChange}
                                potentialWorkerBonus={potentialWorkerBonus}
                                workerPool={milestone?.worker_bonus_percent}
                                isPoolActive={milestone?.is_bonus_pool_enabled}
                                potentialTeamBonus={potentialTeamBonus}
                                WorkerWageIncrease={WorkerWageIncrease}
                                showCalculation={showCalculation}
                                setShowCalculation={setShowCalculation}
                                TotalManDays={TotalManDays}
                                TotalWorkedDays={TotalWorkedDays}
                                workerHours={employeeHours}
                                employee={employee}
                                crewError={crewError}
                                handleOnblurCrewChange={handleOnblurCrewChange}
                                goals={calculatedActual}
                                propay={milestone}
                                hidePropayName={true}
                                handleCrewChange={handleCrewChange}
                                handleHoursChange={handleHoursChange}
                            /> :
                            (tab === 'Set-Goal' && <ShowMessageDefaultState value={Number(value)} numericValue={numericValue} overageAmount={overageAmount}/>)
                        }
                        {(tab === '%-complete' && (milestone && employee) && (percentComplete) &&
                          (!isNaN(overageAmount) && overageAmount> 0)) ?
                            <PercentageCompleteHtmlView
                            employee={employee}
                            percentComplete={percentComplete}
                            hoursError={hoursError}
                            crewError={crewError}
                            workerPool={milestone?.worker_bonus_percent}
                            isPoolActive={milestone?.is_bonus_pool_enabled}
                            handleOnblurCrewChange={handleOnblurCrewChange}
                            handleOnblurHoursChange={handleOnblurHoursChange}
                            workerHours={employeeHours}
                            showCalculation={showCalculation}
                            setShowCalculation={setShowCalculation}
                            crewSize={crewSize}
                            goals={calculatedActual}
                            compnayPerDay={compnayPerDay}
                            propay={milestone}
                            hidePropayName={true}
                            handleCrewChange={handleCrewChange}
                            handleHoursChange={handleHoursChange}
                            PerCompletePositiveNegative={PerCompletePositiveNegative}
                            /> :
                            (tab === '%-complete' &&
                            <PercentageDefaultMessage overageAmount={overageAmount}/>)
                        }
                    </Grid>
                </Grid>
            </HasPermission>
    );
};
export default BonusCalculatorDetailPage;